import React from 'react';
import {connect} from 'react-redux';
import {func, bool, object} from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import classnames from 'classnames';
import styles from './mobileNavHeader.scss';
import HamburgerIcon from 'dibs-vg/dist/react/hamburger-menu';
import LogoIcon from 'dibs-vg/dist/react/logo';
import Close from 'dibs-vg/dist/react/close';
import MobileNavFavoriteIcon from '../MobileNavIcons/MobileNavFavorite';
import MobileNavCartContainer from '../MobileNavIcons/MobileNavCartContainer';
import MobileNavDisplayAmount from '../MobileNavDisplayAmount/MobileNavDisplayAmount';
import get from 'lodash.get';

const AMOUNT_MAX_MESSAGES = 99;

export function MobileNavHeader(props) {
    const {useCloseIcon, user, isUserTypeTrade} = props;
    const isUserTrade = isUserTypeTrade || get(user, 'isVerifiedTrade');
    const iconClass = classnames(styles.actionIcon, {
        [styles.closeIcon]: useCloseIcon
    });
    const containerClass = classnames(styles.container, {
        [styles.isTrade]: isUserTrade
    });
    const Icon = useCloseIcon ? Close : HamburgerIcon;
    const unreadMessageCount = get(user, 'conversationSummary.totalUnreadConversationCount') || 0;
    const showUnreadMessageCount = !!unreadMessageCount && !useCloseIcon;
    return (
        <div className={containerClass}>
            <div className={styles.icon} onClick={props.onActionClick}>
                {showUnreadMessageCount && (
                    <i className={styles.messages}>
                        <MobileNavDisplayAmount
                            className={styles.messagesCount}
                            amount={unreadMessageCount}
                            max={AMOUNT_MAX_MESSAGES}
                        />
                    </i>
                )}
                <Icon className={iconClass} />
            </div>
            <div className={styles.logoContainer} onClick={props.handleNavigateAction}>
                <LogoIcon className={styles.logo} />
                {isUserTrade && <div className={styles.trade}>TRADE</div>}
            </div>
            <div className={styles.iconWrapper}>
                <MobileNavFavoriteIcon onClick={props.handleNavigateAction} className={styles.icon} />
                <MobileNavCartContainer onClick={props.handleNavigateAction}
                    user={props.user}
                    className={styles.icon}
                />
            </div>
        </div>
    );
}

MobileNavHeader.defaultProps = {
    onActionClick: () => {},
    handleNavigateAction: () => {}
};

MobileNavHeader.propTypes = {
    onActionClick: func,
    handleNavigateAction: func.isRequired,
    useCloseIcon: bool,
    user: object,
    isUserTypeTrade: bool
};

function mapStateToProps(state) {
    return {
        isUserTypeTrade: state.header.isUserTypeTrade
    };
}

export default createFragmentContainer(
    connect(mapStateToProps)(MobileNavHeader),
    graphql`
        fragment MobileNavHeader_user on User {
            isVerifiedTrade
            conversationSummary {
                totalUnreadConversationCount
            }
            ...MobileNavCartContainer_user
        }
    `
);



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavHeader/MobileNavHeader.jsx